class BuyTower extends BuySlot {
	tower: ITowerPair;

	constructor(tower: ITowerPair) {
		super();

		this.tower = tower;
		let thing = new Tower(tower.skin, tower.dict);
		thing.scale.set(0.6);
		thing.hpBar.visible = false;
		let thingCont = new PIXI.Container();
		thingCont.addChild(thing);

		this.btn.icon.texture = App.renderer.generateTexture(thingCont);
		centerFrickingSprite(this.btn.icon);

		this.cost = (-tower.dict.price) + "";

		this.btn.onClick.addListener(() => {
			if (this.checkTutor()) {
				return;
			}
			this.parent.emit('buyTower', this.tower);
		});
	}
}
